export class Invite {
  id: string;
  password: string;
  name1: string;
  email: string;
  picture1: string;

  name2: string;
  sex: string;
  idcard: string;
  birthday: string;
  highSchool: string;
  isDone1: string;
  university: string;
  isDone2: string;
  graduateSchool: string;
  isDone3: string;
  address: string;
  phone: string;
  resume: string;
  expertise: string;
  timePoint: string;
  price1: string;
  price2: string;
  tool1: string;
  tool2: string;
  isAgree: string; 
  memo: string; 
  point: string;
  picture2: string;
  createTime: string;
  updateTime: string;

  other: string;

  serviceMethod: string;
  teachMethod: string;
  teachingMaterial: string;
  c2: string;
  c3: string;
  c4: string;

  timeOptionList: any;
}
